/* Measured Scents Noir — native forms remain available without JavaScript. */
(() => {
  'use strict';
  const root = (document.body.dataset.root || '/').replace(/\/?$/, '/');
  const status = document.getElementById('ThemeStatus');
  const dialogOpeners = new WeakMap();
  let cartBusy = false;
  const announce = message => { if (status) status.textContent = message; };
  const getDrawer = () => document.getElementById('CartDrawer');
  const cartError = message => {
    const error = getDrawer()?.querySelector('[data-cart-error]');
    if (error) { error.textContent = message; error.hidden = !message; }
  };
  function openDialog(dialog, opener) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    document.querySelectorAll('dialog[open]').forEach(other => { if (other !== dialog) other.close(); });
    dialogOpeners.set(dialog, opener || document.activeElement);
    if (!dialog.open) dialog.showModal();
    return true;
  }
  function initialiseDialogs(scope = document) {
    scope.querySelectorAll('dialog').forEach(dialog => {
      if (dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';
      dialog.addEventListener('close', () => {
        const opener = dialogOpeners.get(dialog);
        if (opener?.isConnected) opener.focus();
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
    });
  }
  function renderCart(html) {
    if (!html) return false;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-cart-content]');
    const current = getDrawer()?.querySelector('[data-cart-content]');
    if (!next || !current) return false;
    current.replaceWith(next);
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = next.dataset.itemCount || '0'; });
    return true;
  }
  async function refreshCart() {
    const url = new URL(root, location.origin);
    url.searchParams.set('sections', 'cart-drawer');
    const response = await fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Your basket could not be refreshed. Please open the basket page.');
    const sections = await response.json();
    if (!renderCart(sections['cart-drawer'])) throw new Error('Your basket could not be refreshed. Please open the basket page.');
  }
  function setCartBusy(busy) {
    cartBusy = busy;
    const drawer = getDrawer();
    drawer?.querySelector('[data-cart-content]')?.setAttribute('aria-busy', String(busy));
    drawer?.querySelectorAll('button[name="checkout"]').forEach(el => { el.disabled = busy; });
  }
  async function updateCart(key, quantity, inputId) {
    if (cartBusy) return;
    setCartBusy(true);
    cartError('');
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: ['cart-drawer'], sections_url: location.pathname })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Your basket could not be updated.');
      if (!renderCart(data.sections?.['cart-drawer'])) await refreshCart();
      announce('Basket updated.');
      if (inputId) document.getElementById(inputId)?.focus();
    } catch (error) {
      // Refresh authoritative quantities after an inventory error or uncertain response.
      try { await refreshCart(); } catch (_) { /* Keep the link to the basket page available. */ }
      cartError(error.message || 'Please try again or open your basket page.');
    } finally { setCartBusy(false); }
  }
  function showMedia(section, id) {
    if (!id) return;
    const slides = [...section.querySelectorAll('[data-media-id]')];
    if (!slides.some(slide => slide.dataset.mediaId === String(id))) return;
    slides.forEach(slide => {
      slide.hidden = slide.dataset.mediaId !== String(id);
      if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause());
    });
    section.querySelectorAll('[data-media-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === String(id))));
  }
  function syncVariant(section, changeUrl = false) {
    const select = section.querySelector('[data-variant-select]');
    if (!select) return;
    const option = select.selectedOptions[0];
    if (!option) return;
    section.querySelectorAll('[data-variant-value]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.variantValue === option.value)));
    const price = section.querySelector('[data-product-price]');
    if (price) price.textContent = option.dataset.price;
    const compare = section.querySelector('[data-compare-price]');
    if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
    const available = option.dataset.available === 'true';
    const add = section.querySelector('[data-add-button]');
    if (add) { add.disabled = !available; add.querySelector('[data-add-label]').textContent = available ? 'Add to basket' : 'Sold out'; }
    const quantity = section.querySelector('input[name="quantity"]');
    if (quantity) {
      quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
      if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
      let value = Math.max(Number(quantity.min), Number(quantity.value) || Number(quantity.min));
      const step = Number(quantity.step) || 1;
      value = Number(quantity.min) + Math.ceil((value - Number(quantity.min)) / step) * step;
      if (quantity.max) value = Math.min(value, Number(quantity.max));
      quantity.value = String(value);
    }
    const dynamicCheckout = section.querySelector('.dynamic-checkout');
    if (dynamicCheckout) dynamicCheckout.hidden = !available;
    showMedia(section, option.dataset.media);
    if (changeUrl) { const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url); }
  }
  async function addToCart(form) {
    const button = form.querySelector('[data-add-button]');
    const label = button?.querySelector('[data-add-label]');
    const errorBox = form.querySelector('[data-product-error]');
    if (!button || button.disabled || form.dataset.busy) return;
    form.dataset.busy = 'true'; button.disabled = true; button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding…';
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
    let added = false;
    try {
      const payload = new FormData(form);
      payload.append('sections', 'cart-drawer'); payload.append('sections_url', location.pathname);
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: payload });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'This sample could not be added. Please try again.');
      added = true;
      if (!renderCart(data.sections?.['cart-drawer'])) await refreshCart();
      cartError(''); openDialog(getDrawer(), button); announce('Sample added to your basket.');
    } catch (error) {
      if (added) { location.assign(`${root}cart`); return; }
      if (errorBox) { errorBox.textContent = error.message || 'Please check your connection and try again.'; errorBox.hidden = false; }
    } finally {
      delete form.dataset.busy; button.removeAttribute('aria-busy');
      const select = form.querySelector('[data-variant-select]');
      button.disabled = select ? select.selectedOptions[0]?.dataset.available !== 'true' : false;
      if (label) label.textContent = button.disabled ? 'Sold out' : 'Add to basket';
    }
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener && openDialog(document.getElementById(opener.dataset.dialogOpen), opener)) event.preventDefault();
    const closer = event.target.closest('[data-dialog-close]');
    if (closer) closer.closest('dialog')?.close();
    const cartLink = event.target.closest('[data-cart-open]');
    if (cartLink && document.body.dataset.cartDrawer === 'true' && getDrawer()) {
      if (openDialog(getDrawer(), cartLink)) { event.preventDefault(); refreshCart().catch(error => cartError(error.message)); }
    }
    const variant = event.target.closest('[data-variant-value]');
    if (variant) {
      const section = variant.closest('[data-product-section]');
      const select = section?.querySelector('[data-variant-select]');
      if (select) { select.value = variant.dataset.variantValue; select.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    const media = event.target.closest('[data-media-target]');
    if (media) showMedia(media.closest('[data-product-section]'), media.dataset.mediaTarget);
    const quantityButton = event.target.closest('[data-quantity]');
    if (quantityButton) {
      const input = quantityButton.closest('.quantity-control')?.querySelector('input');
      if (!input || (input.hasAttribute('data-cart-quantity') && cartBusy)) return;
      const min = Number(input.min) || 0, step = Number(input.step) || 1;
      let value = Math.max(min, (Number(input.value) || min) + Number(quantityButton.dataset.quantity) * step);
      if (input.max) value = Math.min(value, Number(input.max));
      input.value = String(value); input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) { event.preventDefault(); const line = remove.closest('[data-cart-key]'); if (line) updateCart(line.dataset.cartKey, 0); }
    document.querySelectorAll('.nav-dropdown[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
    const mobileMenu = document.querySelector('.mobile-menu[open]');
    if (mobileMenu && !mobileMenu.contains(event.target)) mobileMenu.open = false;
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-variant-select]')) syncVariant(event.target.closest('[data-product-section]'), true);
    if (event.target.matches('[data-cart-quantity]')) {
      const input = event.target, line = input.closest('[data-cart-key]');
      const value = Number(input.value);
      if (!Number.isInteger(value) || value < 0) { input.reportValidity(); return; }
      if (line) updateCart(line.dataset.cartKey, value, input.id);
    }
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('[data-product-form]') && document.body.dataset.cartDrawer === 'true' && getDrawer() && typeof getDrawer().showModal === 'function') {
      event.preventDefault(); if (form.reportValidity()) addToCart(form);
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open],.nav-dropdown[open]').forEach(menu => { menu.open = false; menu.querySelector('summary')?.focus(); });
  });
  function initialiseHeroCarousels(scope = document) {
    const carousels = [];
    if (scope.matches?.('[data-hero-carousel]')) carousels.push(scope);
    scope.querySelectorAll?.('[data-hero-carousel]').forEach(carousel => carousels.push(carousel));
    carousels.forEach(carousel => {
      if (carousel.dataset.carouselReady) return;
      carousel.dataset.carouselReady = 'true';
      const slides = [...carousel.querySelectorAll('[data-hero-slide]')];
      const dots = [...carousel.querySelectorAll('[data-hero-dot]')];
      const prev = carousel.querySelector('[data-hero-prev]');
      const next = carousel.querySelector('[data-hero-next]');
      if (slides.length < 2) return;
      let index = 0;
      let timer;
      const autoplay = carousel.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const interval = Math.max(4000, Number(carousel.dataset.interval) || 7000);
      const show = (nextIndex, userInitiated = false) => {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          if ('inert' in slide) slide.inert = !active;
        });
        dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
          dot.tabIndex = active ? 0 : -1;
        });
        if (userInitiated) restart();
      };
      const stop = () => { if (timer) { clearInterval(timer); timer = undefined; } };
      const start = () => { if (autoplay && !timer) timer = setInterval(() => show(index + 1), interval); };
      const restart = () => { stop(); start(); };
      prev?.addEventListener('click', () => show(index - 1, true));
      next?.addEventListener('click', () => show(index + 1, true));
      dots.forEach(dot => dot.addEventListener('click', () => show(Number(dot.dataset.heroDot), true)));
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', event => { if (!carousel.contains(event.relatedTarget)) start(); });
      carousel.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') { show(index - 1, true); event.preventDefault(); }
        if (event.key === 'ArrowRight') { show(index + 1, true); event.preventDefault(); }
      });
      document.addEventListener('visibilitychange', () => { document.hidden ? stop() : start(); });
      show(0);
      start();
    });
  }
  function escapeHtml(value = '') {
    return String(value).replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));
  }
  function shuffled(items) {
    const copy = [...items];
    for (let i = copy.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
  }
  function discoveryDisplayTitle(product) {
    let title = String(product?.title || 'Fragrance').split(' Fragrance Sample')[0].split(' Fragrance Decant')[0].trim();
    const vendor = String(product?.vendor || '').trim();
    if (vendor) {
      const prefixes = [`${vendor} - `, `${vendor} `];
      prefixes.forEach(prefix => { if (title.toLowerCase().startsWith(prefix.toLowerCase())) title = title.slice(prefix.length).trim(); });
    }
    return title || String(product?.title || 'Fragrance');
  }
  function discoveryPrice(product, currency) {
    const prices = (product?.variants || []).map(variant => Number(variant.price)).filter(Number.isFinite);
    if (!prices.length) return '';
    const min = Math.min(...prices);
    const max = Math.max(...prices);
    let formatted;
    try { formatted = new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency || 'GBP' }).format(min); }
    catch (_) { formatted = `£${min.toFixed(2)}`; }
    return `${max > min ? '<span class="muted">From </span>' : ''}${formatted}`;
  }
  function discoveryCardMarkup(product, currency) {
    const handle = encodeURIComponent(product?.handle || '');
    const url = `${root}products/${handle}`;
    const title = discoveryDisplayTitle(product);
    const vendor = product?.vendor || '';
    const image = product?.image?.src || product?.images?.[0]?.src || '';
    const imageMarkup = image
      ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product?.title || title)}" loading="lazy">`
      : '<div class="placeholder" aria-hidden="true"></div>';
    const availabilityKnown = (product?.variants || []).some(variant => Object.prototype.hasOwnProperty.call(variant, 'available'));
    const available = !availabilityKnown || (product?.variants || []).some(variant => variant.available);
    const badge = available ? '' : '<span class="badge">Sold out</span>';
    return `<div class="discovery-card" data-discovery-card><article class="product-card"><a class="product-card-image" href="${url}" aria-label="${escapeHtml(product?.title || title)}">${imageMarkup}${badge}<span class="card-arrow" aria-hidden="true">↗</span></a><div class="product-card-copy"><p class="eyebrow">${escapeHtml(vendor)}</p><h3><a href="${url}">${escapeHtml(title)}</a></h3><div class="card-bottom"><p>${discoveryPrice(product, currency)}</p><a href="${url}" class="sample-link">Choose size<span class="visually-hidden"> for ${escapeHtml(product?.title || title)}</span> <span aria-hidden="true">↗</span></a></div></div></article></div>`;
  }
  async function initialiseDiscoveryCarousel(carousel) {
    if (carousel.dataset.discoveryReady) return;
    carousel.dataset.discoveryReady = 'true';
    const viewport = carousel.querySelector('[data-discovery-viewport]');
    const track = carousel.querySelector('[data-discovery-track]');
    const prev = carousel.querySelector('[data-discovery-prev]');
    const next = carousel.querySelector('[data-discovery-next]');
    if (!viewport || !track) return;

    const randomise = carousel.dataset.randomise === 'true';
    const handpicked = carousel.dataset.handpicked === 'true';
    const maxProducts = Math.max(2, Number(carousel.dataset.maxProducts) || 100);
    const currency = carousel.dataset.currency || 'GBP';
    const feedUrl = carousel.dataset.feedUrl;

    let feedLoaded = false;
    if (!handpicked && feedUrl) {
      try {
        const response = await fetch(feedUrl, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) throw new Error('Product feed unavailable');
        const data = await response.json();
        let products = Array.isArray(data.products) ? data.products.filter(product => product?.handle) : [];
        if (randomise) products = shuffled(products);
        products = products.slice(0, maxProducts);
        if (products.length > 1) {
          track.innerHTML = products.map(product => discoveryCardMarkup(product, currency)).join('');
          feedLoaded = true;
        }
      } catch (_) {
        // Keep the server-rendered product cards as a no-JS/network fallback.
      }
    }

    let cards = [...track.querySelectorAll('[data-discovery-card]')];
    if (cards.length < 2) { prev?.setAttribute('hidden', ''); next?.setAttribute('hidden', ''); return; }

    // Hand-picked and fallback cards are shuffled here. Feed cards were shuffled before rendering.
    if (randomise && (handpicked || !feedLoaded)) {
      cards = shuffled(cards);
      cards.forEach(card => track.appendChild(card));
    }

    // Duplicate the exact shuffled sequence. When the first sequence has moved out of view,
    // the second is in the identical position, so the loop can reset without a visible jump.
    cards = [...track.querySelectorAll('[data-discovery-card]')];
    cards.forEach(card => {
      const clone = card.cloneNode(true);
      clone.dataset.discoveryClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a,button,input,select,textarea').forEach(el => el.setAttribute('tabindex', '-1'));
      track.appendChild(clone);
    });

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) { prev?.setAttribute('hidden', ''); next?.setAttribute('hidden', ''); return; }

    let offset = 0;
    let cycleWidth = 0;
    let lastTime;
    let frame;
    let paused = false;
    const speed = Math.max(4, Number(carousel.dataset.speed) || 16); // pixels per second

    const measure = () => {
      const originals = [...track.querySelectorAll('[data-discovery-card]:not([data-discovery-clone])')];
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      cycleWidth = originals.reduce((total, card) => total + card.getBoundingClientRect().width, 0) + gap * originals.length;
      if (cycleWidth > 0) offset %= cycleWidth;
      track.style.transform = `translate3d(${-offset}px,0,0)`;
    };
    const tick = time => {
      if (lastTime == null) lastTime = time;
      const delta = Math.min(50, time - lastTime);
      lastTime = time;
      if (!paused && cycleWidth > 0) {
        offset += speed * delta / 1000;
        if (offset >= cycleWidth) offset -= cycleWidth;
        track.style.transform = `translate3d(${-offset}px,0,0)`;
      }
      frame = requestAnimationFrame(tick);
    };
    const nudge = direction => {
      const first = track.querySelector('[data-discovery-card]:not([data-discovery-clone])');
      if (!first || !cycleWidth) return;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      offset = (offset + direction * (first.getBoundingClientRect().width + gap) + cycleWidth) % cycleWidth;
      track.style.transform = `translate3d(${-offset}px,0,0)`;
    };

    prev?.addEventListener('click', () => nudge(-1));
    next?.addEventListener('click', () => nudge(1));
    // Keep moving continuously during normal mouse use. Pause only for keyboard focus/accessibility.
    carousel.addEventListener('focusin', () => { paused = true; });
    carousel.addEventListener('focusout', event => { if (!carousel.contains(event.relatedTarget)) { paused = false; lastTime = undefined; } });
    document.addEventListener('visibilitychange', () => { paused = document.hidden; lastTime = undefined; });
    window.addEventListener('resize', measure, { passive: true });
    if (document.fonts?.ready) document.fonts.ready.then(measure);
    measure();
    frame = requestAnimationFrame(tick);

    carousel.addEventListener('shopify:block:select', () => { paused = true; });
    carousel.addEventListener('shopify:block:deselect', () => { paused = false; lastTime = undefined; });
    carousel._discoveryCleanup = () => { if (frame) cancelAnimationFrame(frame); window.removeEventListener('resize', measure); };
  }
  function initialiseDiscoveryCarousels(scope = document) {
    const carousels = [];
    if (scope.matches?.('[data-discovery-carousel]')) carousels.push(scope);
    scope.querySelectorAll?.('[data-discovery-carousel]').forEach(carousel => carousels.push(carousel));
    carousels.forEach(carousel => { initialiseDiscoveryCarousel(carousel); });
  }
  function initialise(scope = document) { initialiseDialogs(scope); initialiseHeroCarousels(scope); initialiseDiscoveryCarousels(scope); scope.querySelectorAll('[data-product-section]').forEach(section => syncVariant(section)); }
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
